import { Outlet } from 'react-router-dom'
import { useState } from 'react'
import { LogOut, User, ChevronDown } from 'lucide-react'
import { useAuthStore } from '../../../store/authStore'
import AnalyticsChatbot from '../../admin/workflow/AnalyticsChatbot'

const FinanceLayout = () => {
  const { user, signOut } = useAuthStore()
  const [showUserMenu, setShowUserMenu] = useState(false)

  const handleSignOut = async () => {
    try {
      await signOut()
    } catch (error) {
      console.error('Sign out error:', error)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-100">
      <header className="bg-gradient-to-r from-emerald-600 to-emerald-700 text-white p-4 shadow-lg">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
              <span className="text-sm font-bold">FA</span>
            </div>
            <h1 className="text-2xl font-bold">Finance Advisor Portal</h1>
          </div>

          {/* User Menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-2 bg-white bg-opacity-10 hover:bg-opacity-20 px-4 py-2 rounded-lg transition-colors duration-200"
            >
              <User className="h-4 w-4" />
              <span className="text-sm font-medium">
                {user?.firstName || user?.email || 'Finance User'}
              </span>
              <ChevronDown className="h-4 w-4" />
            </button>

            {/* Dropdown Menu */}
            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                <div className="py-1">
                  <div className="px-4 py-2 text-sm text-gray-700 border-b border-gray-100">
                    <div className="font-medium">{user?.firstName || 'Finance User'}</div>
                    <div className="text-gray-500">{user?.email}</div>
                    <div className="text-xs text-emerald-600 mt-1">Finance Advisor</div>
                  </div>
                  <button
                    onClick={handleSignOut}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-200"
                  >
                    <LogOut className="h-4 w-4" />
                    <span>Sign Out</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      <nav className="bg-white shadow-sm border-b border-emerald-200 p-4">
        <div className="container mx-auto">
          <div className="flex space-x-6">
            <a href="/dashboard" className="text-emerald-700 hover:text-emerald-900">Dashboard</a>
            <a href="/clients" className="text-emerald-700 hover:text-emerald-900">Clients</a>
            <a href="/reports" className="text-emerald-700 hover:text-emerald-900">Reports</a>
            <a href="/portfolio" className="text-emerald-700 hover:text-emerald-900">Portfolio</a>
          </div>
        </div>
      </nav>

      <main className="container mx-auto py-8 px-4">
        <Outlet />
      </main>

      {/* Analytics Chatbot - Available site-wide */}
      <AnalyticsChatbot />
    </div>
  )
}

export default FinanceLayout